const env = process.env.URL_ENV || 'development'
const BASE_URL = process.env.BASE_URL || 'http://lavande.id/'
const BE_BASE_URL = process.env.BE_BASE_URL || 'http://api.lavande.id/'

const mapApiUrl = {
  development: 'http://localhost:5000/v1',
}

const image = {
  ilustrationLogin: `${BASE_URL}/images/login.png`,
  ilustrationLogo: `${BASE_URL}/images/logo.svg`,
  ilustrationHighlight: `${BASE_URL}/images/highlight.png`,
  ilustrationDummyImage: `${BASE_URL}/images/dummy.png`,
  ilustrationDummyImageG1: `${BASE_URL}/images/G1.png`,
  ilustrationDummyImageG2: `${BASE_URL}/images/G2.png`,
  ilustrationDummyImageG3: `${BASE_URL}/images/G3.png`,
  ilustrationDummyImageG4: `${BASE_URL}/images/G4.png`,
  ilustrationDummyImageG5: `${BASE_URL}/images/G5.png`,
  ilustrationDummyImageC1: `${BASE_URL}/images/C1.png`,
  ilustrationDummyImageP1: `${BASE_URL}/images/P1.png`,
  ilustrationDummyImageM1: `${BASE_URL}/images/M1.png`,
  // ilustrationMedia1: `${BASE_URL}/ilustration/M1.png`,
  ilustrationDummyImageM1: `${BASE_URL}/images/M1.png`,
  ilustrationMK1: `${BASE_URL}/ilustration/MK1.png`,
  ilustrationMedia1: `${BASE_URL}/images/Media1.svg`,
  ilustrationMedia2: `${BASE_URL}/images/Media2.svg`,
  ilustrationMedia3: `${BASE_URL}/images/Media3.svg`,
  ilustrationMedia4: `${BASE_URL}/images/Media4.svg`,
  ilustrationStatic1: `${BASE_URL}/images/lavande.png`,
  ilustrationPengurus: `${BASE_URL}/images/pengurus.jpg`,
  ilustrationPengawas: `${BASE_URL}/images/pengawas.jpeg`,
  ilustrationPengelola: `${BASE_URL}/images/pengelola.jpeg`,
}

const icon = {
  searchSVG: `${BASE_URL}/icon/search.png`,
  dateSVG: `${BASE_URL}/icon/date.png`,
  dateWhiteSVG: `${BASE_URL}/icon/dateWhite.svg`,
  dotSVG: `${BASE_URL}/icon/dot.svg`,
  ArrowSVG: `${BASE_URL}/icon/arrow.svg`,
  RectangleGroupSVG: `${BASE_URL}/icon/rectangleGroup.svg`,
  IWallet: `${BASE_URL}/icon/IWallet.svg`,
  ILocation: `${BASE_URL}/icon/ILocation.svg`,
  IUser: `${BASE_URL}/icon/IUser.svg`,
  IWhatsapp: `${BASE_URL}/icon/WA.svg`,
  ICS: `${BASE_URL}/icon/ICS.svg`,
  IGDetailInformation: `${BASE_URL}/icon/IGIconDetail.svg`,
  TwitterDetailInformation: `${BASE_URL}/icon/TwitterIconDetail.svg`,
  aboutUs1: `${BASE_URL}/icon/aboutUs1.svg`,
  aboutUs2: `${BASE_URL}/icon/aboutUs2.svg`,
  aboutUs3: `${BASE_URL}/icon/aboutUs3.svg`,
  aboutUs4: `${BASE_URL}/icon/aboutUs4.svg`,
  aboutUs5: `${BASE_URL}/icon/aboutUs5.svg`,
  aboutUs6: `${BASE_URL}/icon/aboutUs6.svg`,
  phone: `${BASE_URL}/icon/phone.svg`,
  mail: `${BASE_URL}/icon/mail.svg`,
  marker: `${BASE_URL}/icon/marker.png`,
}

const ilustration = {
  informationIlustration1: `${BASE_URL}/ilustration/I1.svg`,
  informationIlustration2: `${BASE_URL}/ilustration/I2.svg`,
  informationIlustration3: `${BASE_URL}/ilustration/I3.svg`,
  informationIlustration4: `${BASE_URL}/ilustration/I4.svg`,
  informationIlustration5: `${BASE_URL}/ilustration/I5.svg`,
  informationIlustration6: `${BASE_URL}/ilustration/I6.svg`,
  informationIlustration7: `${BASE_URL}/ilustration/I7.svg`,
  informationIlustration8: `${BASE_URL}/ilustration/I8.svg`,
  informationIlustration9: `${BASE_URL}/ilustration/I9.svg`,
  comoingSoonIlustration: `${BASE_URL}/ilustration/ComongSoon.svg`,
  staticPageIllustration1: `${BASE_URL}/ilustration/SB1.svg`,
  staticPageIllustration2: `${BASE_URL}/ilustration/SB2.svg`,
}

module.exports = {
  // BASE_API_URL: mapApiUrl[env],
  BASE_API_URL: process.env.BE_URL || 'http://api.lavande.id/v1',
  image,
  icon,
  ilustration,
  BASE_URL,
  BE_BASE_URL,
}
